// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__pIPqv","title":"CardHeader_title__SRL6T"};